import { useEffect, useRef, useState } from 'react';

export default function Products() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const products = [
    {
      image: 'https://public.readdy.ai/ai/img_res/60d5659bef11d2e577acd098fc2a3945.jpg',
      title: 'Linha Suprema',
      description: 'As esquadrias de alumínio da linha Suprema são indicadas para projetos com peças delicadas, como janelas, persianas ou maxim-ar, já que os perfis da linha suprema contam com uma leveza nos materiais. É ideal para projetos que não necessitam de muita robustez. A linha suprema conta com a possibilidade de acabamento com vidros comuns de 4mm e até temperados de 6mm.',
      specs: 'Vidros de 4mm até 6mm',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Premium%20aluminum%20sliding%20door%20frame%20with%20reinforced%20profile%20showing%20sophisticated%20silver%20metallic%20construction%20in%20modern%20interior%20design%20setting%20with%20minimalist%20white%20background%20and%20studio%20lighting%20emphasizing%20the%20robust%20frame%20structure%20ideal%20for%20larger%20installations&width=400&height=400&seq=gold-line-door&orientation=squarish',
      title: 'Linha Gold',
      description: 'As esquadrias de alumínio da linha Gold são perfis mais reforçados, ideal para projetos com peças de portes maiores, como portas de correr ou portas de giro. É ideal para projetos que necessitam de uma rigidez um pouco maior. A linha Gold conta com a possibilidade de acabamento com vidros temperados de 6mm à 10mm.',
      specs: 'Vidros de 6mm até 10mm',
    },
  ];

  return (
    <section ref={sectionRef} className="py-12 md:py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <span className="text-xs md:text-sm font-semibold text-gray-500 uppercase tracking-wide">
            Conheça nossas principais
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mt-3 md:mt-4 mb-4 md:mb-6">
            Linhas de Produtos
          </h2>
          <p className="text-sm md:text-base text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
            As linhas são as opções de perfis que iremos utilizar nos projetos de esquadrias. A equipe Primavera presta todo o suporte na escolha técnica e estética dos materiais.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          {products.map((product, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-700 transform hover:-translate-y-2 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="h-48 md:h-64 overflow-hidden bg-gray-100 w-full">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4 md:p-6 lg:p-8 bg-white">
                <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
                  {product.title}
                </h4>
                <p className="text-xs md:text-sm text-gray-600 mb-4 md:mb-6 leading-relaxed">
                  {product.description}
                </p>
                <div className="flex items-center space-x-2 pt-3 md:pt-4 border-t border-gray-200">
                  <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                    <img
                      src="https://primaveraesquadrias.com.br/wp-content/uploads/2023/06/event_seat.png"
                      alt="icon"
                      className="w-full h-full"
                    />
                  </div>
                  <span className="text-xs md:text-sm text-gray-700 font-medium">
                    {product.specs}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
